/**
 * Transform Component
 *
 * Position, rotation, and scale in 2D space.
 */

import {
  component,
  displayName,
  icon,
  color,
  category,
  allowMultiple,
  field,
  customEditor,
} from "../attributes";

@component("core.Transform")
@customEditor("TransformEditor")
@displayName("Transform")
@icon("Move")
@color("#00d4ff")
@category("Core")
@allowMultiple(false)
export class Transform {
  @field({ type: "f32", label: "Position X" })
  x: number = 0;

  @field({ type: "f32", label: "Position Y" })
  y: number = 0;

  @field({ type: "f32", label: "Rotation", min: -Math.PI, max: Math.PI })
  rotation: number = 0;

  @field({ type: "f32", label: "Scale X" })
  scaleX: number = 1;

  @field({ type: "f32", label: "Scale Y" })
  scaleY: number = 1;

  @field({ type: "i32", label: "Layer", min: 0, max: 100 })
  layer: number = 0;
}
